

import dayjs from "dayjs";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CURRENCY, NUMBER ,DATE_DISABLE_NO_DAY} = FIELD_TYPE;

const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Đánh giá chuyên môn",
    name: "danhGiaChuyenMon",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
    wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},

  },
];
const dataFieldKQ: DataFormField[] = [
  {
    type: DATE_DISABLE_NO_DAY,
    name: "ngayNhanViec",
    label: "Ngày nhận việc",
    disable: false,
    optionsTime: {
        showTime: true,
        format: FORMAT_TIME.dayFull,
      },
      css: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
      wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},
  },
  {
    type: INPUT,
    label: "Ngoại hình (nhìn bề ngoài)",
    name: "ngoaiHinh",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
    wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},

  },
  {
    type: INPUT,
    name: "phongCachThaiDo",
    label: "Phong cách, thái độ",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
    wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},


  },
  {
    type: INPUT,
    name: "giongNoi",
    label: "Giọng nói",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
    wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},

  },
  {
    type: INPUT,
    label: "Tình trạng sức khỏe hiện tại",
    name: "tinhTrangSucKhoeHienTai",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
    wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},

  },
  {
    type: INPUT,
    label: "Trình độ chuyên môn",
    name: "trinhDoChuyenMon",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
    wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},

  },
  {
    type: INPUT,
    label: "Kinh nghiệm làm việc",
    name: "kinhNghiemLamViec",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
    wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},

  },
  {
    type: INPUT,
    label: "Khả năng trình bày, giao tiếp",
    name: "khaNangTrinhBayGiaoTiep",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
    wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},

  },
  {
    type: INPUT,
    label: "Khả năng giải quyết tình huống",
    name: "giaiQuyetTinhHuong",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
    wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},

  },
  {
    type: INPUT,
    label: "Khả năng làm việc nhóm",
    name: "khaNangLamViecNhom",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
    wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},

  },




];
export {dataFieldKQ,dataFields};

